import { useEffect } from "react";

type OutsideClickCallback = () => void;

export function useOutsideClick(
  ref: any,
  callback: OutsideClickCallback
) {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
        
      // Only run if ref exists and click was outside the element
      if (ref.current && !ref.current.contains(e.target as Node)) {
        callback();
      }
    }

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref, callback]);
}
